import React from "react";
import { Form, } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { useRef, useEffect, useState } from 'react';
import { InputFieldKYC, } from "../BusinessFlow/Kycform";
import Cookies from 'js-cookie';
import { decrypt } from "../utils";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css"; // or any theme
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { COMPLIANCE_REJECTED } from "../utilities";





const InvestorPersonalDetails = ({
    indivInvFormData,
    handleFieldChange,
    onBack,
    onNext,
    validatePersonalErrors,
    setValidatePersonalErrors,
    bankStatementError,
    handleBankStatementChange,
    setBankStatementError,
    removeCompletedStep,
    handleSaveKYCDraft,
    handleViewFile,
    handleDeleteFile,
    investorDatauser,

}) => {

    const [role_code, setRoleCode] = useState(Cookies.get("role_code"));

    useEffect(() => {
        if (role_code) {
            const decryptedValueData = decrypt(role_code)
            setRoleCode(decryptedValueData);
        }
    }, [])

    const bankStatementInputRef = useRef(null);
    const addressProofInputRef = useRef(null);



    const calculateAge = (dob) => {
        if (!dob) return null;

        let birthDate;

        if (dob instanceof Date) {
            birthDate = dob;
        } else if (typeof dob === "number") {
            birthDate = new Date(dob);
        } else if (typeof dob === "string") {
            const [day, month, year] = dob.split("-");
            birthDate = new Date(year, month - 1, day);
        } else {
            return null;
        }

        if (isNaN(birthDate.getTime())) return null;
        if (birthDate > new Date()) return null;

        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    };



    const nomineeDob = indivInvFormData?.nominee_dob
        ? (() => {
            const d = new Date(Number(indivInvFormData.nominee_dob));
            const day = String(d.getDate()).padStart(2, "0");
            const month = String(d.getMonth() + 1).padStart(2, "0");
            const year = d.getFullYear();
            return `${day}-${month}-${year}`; // d-m-Y
        })()
        : "";

    const nomineeAge = calculateAge(nomineeDob);


    const isMinor = nomineeAge !== null && nomineeAge < 18;

    const guardianDob = indivInvFormData?.guardian_dob
        ? (() => {
            const d = new Date(Number(indivInvFormData.guardian_dob));
            const day = String(d.getDate()).padStart(2, "0");
            const month = String(d.getMonth() + 1).padStart(2, "0");
            const year = d.getFullYear();
            return `${day}-${month}-${year}`; // d-m-Y
        })()
        : "";

    const validateGuardianDOBOnChange = (guardianDob, nomineeDob) => {
        if (!guardianDob) {
            return "Guardian date of birth is required";
        }

        const guardianAge = calculateAge(guardianDob);
        if (guardianAge === null) {
            return "Invalid guardian date of birth";
        }

        if (guardianAge < 18) {
            return "Guardian must be at least 18 years old";
        }

        if (nomineeDob) {
            const [d1, m1, y1] = guardianDob.split("-");
            const [d2, m2, y2] = nomineeDob.split("-");

            const guardianDate = new Date(y1, m1 - 1, d1);
            const nomineeDate = new Date(y2, m2 - 1, d2);

            if (guardianDate >= nomineeDate) {
                return "Guardian must be older than the nominee";
            }
        }

        return "";
    };

    const getGuardianMaxDobFromNominee = (nomineeDob) => {
        if (!nomineeDob) return null;

        let nomineeDate;

        // If it's string in DD-MM-YYYY
        if (typeof nomineeDob === "string") {
            const [day, month, year] = nomineeDob.split("-");
            nomineeDate = new Date(year, month - 1, day);
        } else {
            // If timestamp
            nomineeDate = new Date(nomineeDob);
        }

        if (isNaN(nomineeDate.getTime())) return null;

        return new Date(
            nomineeDate.getFullYear() - 18,
            nomineeDate.getMonth(),
            nomineeDate.getDate()
        );
    };


    const getGuardianMaxDob = () => {
        const today = new Date();

        return new Date(
            today.getFullYear() - 18,
            today.getMonth(),
            today.getDate()
        );
    };


    const isValidDobTimestamp = (dob) => {
        if (!dob || typeof dob !== "number") return false;

        const d = new Date(dob);
        if (isNaN(d.getTime())) return false;

        // DOB must not be in the future
        return d <= new Date();
    };


    const validateMandatoryFields = () => {
        const newErrors = {};

        const nominee_name = indivInvFormData?.nominee_name
        const nominee_dob = indivInvFormData?.nominee_dob

        const nominee_contact = indivInvFormData?.nominee_contact
        const nominee_relationship = indivInvFormData?.nominee_relationship

        const guardian_name = indivInvFormData?.guardian_name
        const guardian_dob = indivInvFormData?.guardian_dob

        const guardian_address = indivInvFormData?.guardian_address
        const is_pep = indivInvFormData?.is_pep;

        if (!nominee_name) newErrors.nominee_name = true;

        if (!isValidDobTimestamp(nominee_dob)) {
            newErrors.nominee_dob = true;
        }

        if (!nominee_contact) {
            // Only mark red border
            newErrors.nominee_contact = true;
        }


        if (!nominee_relationship) newErrors.nominee_relationship = true;

        if (isMinor) {
            if (!guardian_name) newErrors.guardian_name = true;
            if (!isValidDobTimestamp(guardian_dob)) {
                newErrors.guardian_dob = true;
            }

            if (!guardian_address) newErrors.guardian_address = true;
        }
        if (!is_pep) {
            newErrors.is_pep = true;
        }
        if (

            !indivInvFormData?.bank_statement_blob_url &&
            !indivInvFormData?.bank_statement_file_name
        ) {
            newErrors.bank_statement = true;
            setBankStatementError(true);
        }
        else {
            setBankStatementError(false);
        }
        setValidatePersonalErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleNomineePhoneChange = (e) => {
        let value = e.target.value;

        //  Allow only digits and +
        if (!/^[0-9+]*$/.test(value)) return;

        // Only one +
        if ((value.match(/\+/g) || []).length > 1) return;

        // + must be at start
        if (value.includes("+") && value[0] !== "+") return;


        // limit max length
        if (value.length > 15) return;

        handleFieldChange("nominee_contact", value);


    };

    const reason = investorDatauser?.kyc?.[0]?.admin_notes;

    const truncateWords = (text, limit = 35) => {
        if (!text) return "";

        if (text.length <= limit) return text;

        return text.substring(0, limit) + "...";
    };

    const renderKycStatus = () => {
        if (!investorDatauser?.kyc) return null;


        // if (reason) {
                if (investorDatauser?.kyc?.[0]?.status === COMPLIANCE_REJECTED) {
        
            return (
                <div className="kyc-status kyc-status-rejected">
                    <div>Status: Rejected</div>

                    <div className="kyc-reason">
                        Reason:
                        <span title={reason}
                            style={{ fontSize: "15px" }}>
                            {truncateWords(reason, 35)}
                        </span>
                    </div>
                </div>
            );
        }


        return null;
    };



    const truncateFileName = (name, maxLength = 40) => {
        if (!name) return "";
        return name.length > maxLength
            ? name.substring(0, maxLength) + "..."
            : name;
    };




    return (
        <div className="kyc-poppins-ui">
            <div className="main-content">
                <div className="content-wrapper">

                    <div className="review-header-row">
                        <div className="step-header">
                            <div className="step-title-personal"> Other Details</div>
                            <div className="step-subtitle">Please provide your details exactly as they appear on your government-issued ID.</div>
                        </div>
                        <div className="review-status">
                            {renderKycStatus()}
                        </div>

                    </div>


                    <div
                        style={{
                            marginTop: "10px",
                            paddingTop: "12px",
                            borderTop: "2px solid #e5e7eb",
                            width: "100%",
                        }}
                    >
                        <div className="nominee-header">

                            <h6 className="section-title">
                                Nominee Details
                            </h6>
                            <div className="nominee-subtitle">
                                Kindly fill in your nominee details.
                            </div>
                        </div>



                        <div className="row gap-lg-3">
                            <InputFieldKYC
                                label="Nominee Name"
                                divClass="col-lg-12"
                                mandatory={"*"}
                                id="nominee_name"
                                name="nominee_name"
                                htmlFor="nominee_name"
                                placeholder="Enter nominee name"
                                error={validatePersonalErrors.nominee_name}
                                onChange={(e) => handleFieldChange('nominee_name', e.target.value)}
                                value={indivInvFormData?.nominee_name}

                            />


                        </div>

                        <div className="row allow-gutter gy-3">

                            <div className="col-lg-6 settings_YOE">
                                <label className="nomine-relation-label"
                                >
                                    Date of Birth
                                    <span className="required">*</span>
                                </label>
                                <Flatpickr
                                    options={{
                                        dateFormat: "d-m-Y",     // DD-MM-YYYY
                                        maxDate: "today",        // disable future dates
                                        allowInput: false,        // allow typing
                                        monthSelectorType: "dropdown", // easier DOB selection
                                        yearSelectorType: "dropdown",
                                    }}

                                    value={nomineeDob}
                                    onChange={([date]) =>
                                        handleFieldChange(
                                            "nominee_dob",
                                            date ? date.getTime() : null
                                        )
                                    }

                                    className={`form-control bg-white ${validatePersonalErrors.nominee_dob ? "input-error" : ""
                                        }`}

                                    placeholder="dd-mm-yyyy"
                                />
                            </div>
                            <div className="col-lg-6 settings_YOE">
                                <InputFieldKYC
                                    label="Contact Number"
                                    mandatory={"*"}
                                    // divClass="col-lg-6"
                                    id="nominee_contact"
                                    name="nominee_contact"
                                    htmlFor="nominee_contact"
                                    type="tel"
                                    maxLength={10}
                                    error={validatePersonalErrors.nominee_contact}
                                    placeholder="Enter contact number"

                                    onChange={handleNomineePhoneChange}
                                    value={indivInvFormData?.nominee_contact}

                                />
                                {typeof validatePersonalErrors.nominee_contact === "string" && (
                                    <div className="text-danger small mt-1">
                                        {validatePersonalErrors.nominee_contact}
                                    </div>
                                )}
                            </div>
                        </div>


                        <div className="row allow-gutter gy-3">

                            <div className="col-lg-6 settings_YOE">
                                <label htmlFor="nominee_relationship" className="nomine-relation-label">
                                    Relationship <span className="required">*</span>
                                </label>

                                <select
                                    className={`form-select dropdn_select_cls_settings shadow-ben APNL_option_flds ${validatePersonalErrors.nominee_relationship ? "input-error" : ""
                                        }`}
                                    aria-label="Relationship"
                                    id="nominee_relationship"
                                    name="nominee_relationship"
                                    autoComplete="off"

                                    value={
                                        indivInvFormData?.nominee_relationship
                                    }
                                    onChange={(e) =>
                                        handleFieldChange("nominee_relationship", e.target.value)
                                    }
                                >
                                    <option value="">Select</option>

                                    {["Spouse", "Parent", "Child", "Sibling", "Others"].map(
                                        (relation) => (
                                            <option key={relation} value={relation}>
                                                {relation}
                                            </option>
                                        )
                                    )}
                                </select>
                            </div>
                        </div>


                        {isMinor && (
                            <div className="guardian-section mt-4 p-3 border rounded bg-warning-subtle">

                                <h6 className="fw-bold text-warning d-flex align-items-center gap-2">
                                    <svg width="18" height="18" fill="#f59e0b" viewBox="0 0 24 24">
                                        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path>
                                    </svg>
                                    Guardian Details Required (Nominee is under 18)
                                </h6>

                                <div className="nominee-subtitle">
                                    Since the nominee is a minor, please provide guardian information
                                </div>


                                <div className="row allow-gutter gy-3">

                                    <InputFieldKYC
                                        divClass="col-lg-6"
                                        label="Guardian Name"
                                        mandatory="*"
                                        id="guardian_name"
                                        name="guardian_name"
                                        htmlFor="guardian_name"
                                        placeholder="Full name of guardian"
                                        error={validatePersonalErrors.guardian_name}

                                        onChange={(e) => handleFieldChange('guardian_name', e.target.value)}
                                        value={indivInvFormData?.guardian_name}

                                    />


                                    <div className="col-lg-6 settings_YOE">
                                        <label className="nomine-relation-label"
                                        >
                                            Guardian Date of Birth
                                            <span className="required">*</span>
                                        </label>
                                        <Flatpickr
                                            options={{
                                                dateFormat: "d-m-Y",     // DD-MM-YYYY


                                                // maxDate: getGuardianMaxDobFromNominee(nomineeDob),
                                                maxDate: getGuardianMaxDob(),
                                                allowInput: false,        // allow typing
                                                monthSelectorType: "dropdown", // easier DOB selection
                                                yearSelectorType: "dropdown",
                                            }}
                                            value={guardianDob}


                                            onChange={([date]) =>
                                                handleFieldChange(
                                                    "guardian_dob",
                                                    date
                                                        ? Date.UTC(
                                                            date.getFullYear(),
                                                            date.getMonth(),
                                                            date.getDate()
                                                        )
                                                        : null
                                                )
                                            }

                                            error={validatePersonalErrors.guardian_dob}
                                            className={`form-control bg-white ${validatePersonalErrors.guardian_dob ? "input-error" : ""}`}

                                            placeholder="dd-mm-yyyy"

                                        />
                                        {validatePersonalErrors.guardian_dob && (
                                            <div className="error-text mt-1">
                                                {validatePersonalErrors.guardian_dob}
                                            </div>
                                        )}
                                    </div>

                                </div>

                                <div className="row mt-2">
                                    <div className="pe-2">
                                        <p className="nomine-relation-label mb-2">
                                            Guardian Address <span className="required">*</span>
                                        </p>
                                        <Form.Group className="text_area_placeholder">
                                            <Form.Control
                                                size="sm"
                                                className={`ANLtextarea ${validatePersonalErrors.guardian_address ? "input-error" : ""
                                                    }`}
                                                as="textarea"
                                                rows={2}
                                                placeholder="Full address of guardian"

                                                onChange={(e) => handleFieldChange('guardian_address', e.target.value)}
                                                value={indivInvFormData?.guardian_address}

                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>




                    <div className="d-flex align-items-center gap-4 flex-nowrap" style={{ marginTop: "24px" }}>

                        <label
                            className="kyc-label mb-0 text-nowrap d-inline-flex align-items-center"
                            style={{ fontSize: "15px", fontWeight: 500 }}
                        >
                            Are you a politically exposed person
                            <span className="required">*</span>


                            <span
                                data-tooltip-id="pep-tooltip"
                                data-tooltip-place="top"
                                data-tooltip-offset={8}
                                data-tooltip-position-strategy="fixed"
                                className="pep-info-icon"
                                aria-label="Politically Exposed Person info"
                            >
                                i
                            </span>

                            <Tooltip
                                id="pep-tooltip"
                                place="top"
                                className="pep-tooltip"
                            >
                                PEPs are individuals who are or have been entrusted with prominent public
                                functions by a country, for example Heads of State or of government, senior
                                politicians, senior government, judicial or military officials, senior
                                executives of state owned corporations, important political party officials.
                            </Tooltip>

                        </label>


                        <div className="d-flex align-items-center gap-4">
                            <div className="d-flex align-items-center">
                                <input
                                    type="radio"
                                    id="yesRadio"
                                    name="is_pep"
                                    checked={

                                        indivInvFormData?.is_pep === "Yes"
                                    }
                                    onClick={() => handleFieldChange("is_pep", "Yes")}
                                />
                                <label htmlFor="yesRadio" className="ms-2 mb-0">
                                    Yes
                                </label>
                            </div>

                            <div className="d-flex align-items-center">
                                <input
                                    type="radio"
                                    id="noRadio"
                                    name="is_pep"
                                    checked={

                                        indivInvFormData?.is_pep === "No"
                                    }
                                    onClick={() => handleFieldChange("is_pep", "No")}
                                />
                                <label htmlFor="noRadio" className="ms-2 mb-0">
                                    No
                                </label>
                            </div>
                        </div>


                    </div>
                    {validatePersonalErrors.is_pep && (
                        <p className="text-danger mt-1 mb-0" style={{ fontSize: "13px" }}>
                            Please select
                        </p>
                    )}

                    <div
                        style={{
                            marginTop: "30px",
                            paddingTop: "17px",
                            borderTop: "2px solid #e5e7eb",
                            width: "100%",
                        }}
                    >



                        {/* ===================== SECTION HEADERS (PARALLEL) ===================== */}
                        <div className="upload-grid mb-3">
                            {/* LEFT HEADER */}
                            <div>

                                <h6 className="section-title">

                                    Bank Statement
                                </h6>
                                <div className="nominee-subtitle">
                                    Your last 3 months bank statement <span className="required">*</span>
                                </div>
                            </div>

                            {/* RIGHT HEADER */}
                            <div>
                                <h6 className="section-title">
                                    Address Proof <span className="text-muted">(Optional)</span>
                                </h6>
                                <div className="nominee-subtitle">
                                    Your valid address proof
                                    <span
                                        data-tooltip-id="bank=tooltip"
                                        data-tooltip-place="top"
                                        data-tooltip-offset={8}
                                        data-tooltip-position-strategy="fixed"
                                        className="pep-info-icon"
                                    > i
                                    </span>
                                    <Tooltip
                                        id="bank=tooltip"
                                        place="top"
                                        className="pep-tooltip"
                                    >
                                        In case address is not mentioned on the bank statement or is not
                                        applicable, please attach a valid address proof like utility bill
                                        within last 3 months or valid tenancy contract.
                                    </Tooltip>
                                </div>
                            </div>
                        </div>

                        <div className="upload-grid">
                            {/* ===================== BANK STATEMENT UPLOAD ===================== */}
                            <div className="form-group">
                                <div

                                    className={`upload-area
                                    ${bankStatementError ? "input-error" : ""}
                                    ${indivInvFormData?.bank_statement_file_name ? "has-file" : ""}
                                       `}
                                    onClick={() => bankStatementInputRef.current.click()}
                                >
                                    {!indivInvFormData?.bank_statement_file_name && (
                                        <svg width="40" height="40" fill="#9ca3af" viewBox="0 0 24 24">
                                            <path d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z" />
                                        </svg>
                                    )}

                                    {indivInvFormData?.bank_statement_file_name && (

                                        <svg width="40" height="40" viewBox="0 0 24 24">
                                            <circle cx="12" cy="12" r="10" fill="#10b981" />
                                            <path
                                                d="M8 12.5l2.5 2.5L16 9"
                                                fill="none"
                                                stroke="#ffffff"
                                                strokeWidth="2.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    )}

                                    <p className="upload-title">
                                        {indivInvFormData?.bank_statement_file_name
                                            ? "Uploaded"
                                            : "Upload Bank Statement"}
                                    </p>


                                    <p className={`upload-hint ${indivInvFormData?.bank_statement_file_name ? "hidden" : ""}`}>
                                        PDF format only, up to 10MB
                                    </p>


                                    <span className="file-name"
                                        title={indivInvFormData?.bank_statement_file_name || ""}
                                    > {truncateFileName((indivInvFormData?.bank_statement_file_name), 40) || "No file selected"}
                                    </span>

                                    {indivInvFormData?.bank_statement_file_name && (
                                        <div
                                            className="file-actions"
                                            onClick={(e) => e.stopPropagation()} // prevent re-upload click
                                        >
                                            {/* View */}
                                            <button
                                                type="button"
                                                className="icon-btn view"
                                                title="View file"
                                                onClick={() => handleViewFile("bank_statement")}

                                            >
                                                <FaEye
                                                    className="eye-view-color-kyc"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"


                                                />
                                            </button>

                                            {/* REMOVE */}
                                            <button
                                                type="button"
                                                className="icon-btn cancel"
                                                title="Remove file"
                                                onClick={() => handleDeleteFile("bank_statement")}
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    )}

                                </div>

                                <input
                                    type="file"
                                    ref={bankStatementInputRef}
                                    accept="application/pdf"
                                    hidden
                                    onChange={(e) => handleBankStatementChange(e, "bank")}

                                />
                            </div>

                            {/* ===================== ADDRESS PROOF UPLOAD ===================== */}
                            <div className="form-group">


                                <div
                                    className={`upload-area
                                    ${indivInvFormData?.address_proof_file_name ? "has-file" : ""}
                                       `}

                                    onClick={() => addressProofInputRef.current.click()}
                                >
                                    {!indivInvFormData?.address_proof_file_name && (
                                        <svg width="40" height="40" fill="#9ca3af" viewBox="0 0 24 24">
                                            <path d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z" />
                                        </svg>
                                    )}
                                    {indivInvFormData?.address_proof_file_name && (

                                        <svg width="40" height="40" viewBox="0 0 24 24">
                                            <circle cx="12" cy="12" r="10" fill="#10b981" />
                                            <path
                                                d="M8 12.5l2.5 2.5L16 9"
                                                fill="none"
                                                stroke="#ffffff"
                                                strokeWidth="2.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    )}

                                    <p className="upload-title">
                                        {indivInvFormData?.address_proof_file_name
                                            ? "Uploaded"
                                            : "Upload Address Proof"}
                                    </p>

                                    <p className={`upload-hint ${indivInvFormData?.address_proof_file_name ? "hidden" : ""}`}>
                                        PDF format only, up to 10MB
                                    </p>

                                    <span className="file-name"
                                        title={indivInvFormData?.address_proof_file_name || ""}
                                    >                                      {truncateFileName((indivInvFormData?.address_proof_file_name), 40) || "No file selected"}

                                    </span>


                                    {indivInvFormData?.address_proof_file_name && (
                                        <div
                                            className="file-actions"
                                            onClick={(e) => e.stopPropagation()} // prevent re-upload click
                                        >
                                            {/* View */}
                                            <button
                                                type="button"
                                                className="icon-btn view"
                                                title="View file"
                                                onClick={() => handleViewFile("address_proof")}

                                            >
                                                <FaEye
                                                    className="eye-view-color-kyc"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"


                                                />
                                            </button>

                                            {/* REMOVE */}
                                            <button
                                                type="button"
                                                className="icon-btn cancel"
                                                title="Remove file"
                                                onClick={() => handleDeleteFile("address_proof")}
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    )}


                                </div>

                                <input
                                    type="file"
                                    ref={addressProofInputRef}
                                    accept="application/pdf"
                                    hidden
                                    onChange={(e) => handleBankStatementChange(e, "address")}

                                />
                            </div>
                        </div>



                    </div>




                    <div className="button-group">
                        <button
                            className="btn btn-secondary"
                            onClick={() => {
                                sessionStorage.setItem("fromPersonal", "true");
                                onBack(); //  execute function
                            }}
                        >
                            ← Back
                        </button>

                        <button className="btn btn-primary"
                            onClick={() => {

                                const isValid = validateMandatoryFields();

                                if (!isValid) {
                                    removeCompletedStep(2); //  Personl Info invalid → remove tick
                                    return; //  stop navigation
                                }
                                handleSaveKYCDraft()
                                onNext();
                            }}

                        >Continue →</button>
                    </div>
                </div>
            </div>
        </div >

    );
};

export default InvestorPersonalDetails;
